import { logger } from 'common/services/logger';

export const isAccinCommunity = (communityId: string): boolean => {
  if (!window._env_?.VITE_APP_ACCIN_COMMUNITY_ID) {
    logger.error('VITE_APP_ACCIN_COMMUNITY_ID is not configured');
    return false;
  }
  return String(communityId) === String(window._env_.VITE_APP_ACCIN_COMMUNITY_ID);
};
